import { render, staticRenderFns } from "./scrollRefresh.vue?vue&type=template&id=c20b8a0c&scoped=true&"
import script from "./scrollRefresh.vue?vue&type=script&lang=js&"
export * from "./scrollRefresh.vue?vue&type=script&lang=js&"
import style0 from "./scrollRefresh.vue?vue&type=style&index=0&id=c20b8a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20b8a0c",
  null
  
)

export default component.exports